import useQuestions from "../../hooks/useAuditQuestions";
import Question from "../contractorAudit/auditQuestions/Question";
import useFormPage2 from "./useFormPage2";
import SectionHeader from "../../components/ui/labels/SectionHeader";
import QuestionSection from "../contractorAudit/auditQuestions/QuestionSection";

const FormPage2 = ({ state, dispatch, ACTIONS }) => {
  const { splicerQuestions } = useQuestions();
  const { questionInputHandler } = useFormPage2({
    dispatch,
    ACTIONS,
  });

  /*
    Render a question component by finding the matching
    question's GUID from the state's questions value (from
    COLLECTOR_AUDIT_QUESTIONS)
  */
  const renderQuestion = (guid) => {
    let question = state.questions.find((obj) => {
      return obj.QUESTION_GUID === guid;
    });
    return question ? (
      <Question
        questionGUID={question.QUESTION_GUID}
        question={question.QUESTION}
        inputHandler={questionInputHandler}
      />
    ) : (
      <></>
    );
  };

  return (
    <>
      <SectionHeader text="Questions" overrideFontSize={"24px"} />
      <QuestionSection title="Required PPE">
        {renderQuestion(splicerQuestions.requiredPPE)}
      </QuestionSection>
      <QuestionSection title="Required WAP">
        {renderQuestion(splicerQuestions.requiredWAP)}
      </QuestionSection>
      <QuestionSection title="Fiber Splicing">
        {renderQuestion(splicerQuestions.fiberSplicing)}
      </QuestionSection>
      <QuestionSection title="Housekeeping">
        {renderQuestion(splicerQuestions.housekeeping)}
      </QuestionSection>
    </>
  );
};

export default FormPage2;
